import gql from 'graphql-tag'
import { sharedEventDataFragment } from '../fragments/sharedEventData'

const eventTypeDataFragment = gql`
  fragment eventTypeData on EventType {
    id
    slug
    title
    startDate
    endDate
    availableTicketsCount
  }
`

export const GET_EVENT_DATA = gql`
  query getEventData($id: ID!) {
    node(id: $id) {
      ... on Event {
        ...sharedEventData
        availableTicketsCount
        soldTicketsCount
        ticketAlertsCount
        entranceTypes: types(first: 99, filter: { ticketCategory: ENTRANCE }) {
          edges {
            node {
              ...eventTypeData
            }
          }
        }
        nonEntranceTypesWithoutGroup: types(
          first: 99
          filter: { ticketCategory: NON_ENTRANCE, hasGroup: false }
        ) {
          edges {
            node {
              ...eventTypeData
            }
          }
        }
        eventTypeGroups {
          id
          name
          eventTypes {
            ...eventTypeData
          }
        }
        redirectedTo {
          id
          slug
        }
        availableListings: listings(
          first: 2
          filter: { listingStatus: AVAILABLE }
        ) {
          edges {
            node {
              seller {
                id
                avatar
              }
            }
          }
        }
        soldListings: listings(first: 2, filter: { listingStatus: SOLD }) {
          edges {
            node {
              seller {
                id
                avatar
              }
            }
          }
        }
        usersWithTicketAlerts(first: 8) {
          edges {
            node {
              id
              avatar
            }
          }
        }
      }
    }
  }
  ${sharedEventDataFragment}
  ${eventTypeDataFragment}
`
